import { getScoreCategory, type NpsBrandConfig } from "@repo/nps";
import { NPS_COMPLETED_VALUES } from "@repo/statsig";
import PRODUCT_NAME from "src/lib/product-name";

/**
 * Owlet OnCall survey config (per the OnCall NPS PRD): 30-day cooldown, a
 * 14-day "Not now" deferral, no thank-you illustration, and its own approved
 * wording — warmer, non-clinical, and avoiding "Sorry to hear that" on low
 * scores.
 */
export const owletNpsConfig: NpsBrandConfig = {
  cooldownDays: 30,
  deferralDays: 14,
  copy: {
    productName: PRODUCT_NAME,
    question: "How likely are you to recommend Owlet OnCall to other parents?",
    description: "",
    consentLabel: "A team member can follow up about this feedback.",
    confirmation: "Thanks — this helps us improve care for families like yours.",
    followUp: (score: number) => {
      switch (getScoreCategory(score)) {
        case NPS_COMPLETED_VALUES.PROMOTER:
          return "What do you find most valuable about the care you've received through Owlet OnCall?";
        case NPS_COMPLETED_VALUES.PASSIVE:
          return "What would need to change for you to recommend Owlet OnCall to other parents?";
        case NPS_COMPLETED_VALUES.DETRACTOR:
        default:
          return "We'd like to understand — what's the main reason for your score?";
      }
    },
  },
};
